module.exports = __webpack_public_path__ + "source-sans-pro-v11-latin-regular-76d8cbb0496cb184eff868152b67ad45.bundle.woff2";